import tw, { styled } from 'twin.macro';

const Heading1 = styled.h1`
  ${tw`text-2xl sm:text-3xl font-bold leading-tight text-gray-900`};
  ${tw`print:!text-lg`}
`;

export default Heading1;
